import './Attachment.scss';
import { CustomTooltip, Tooltip, MultiFileUpload, EventHandler } from 'client/CommonComponents';
import { Spinner } from "@softura/fluentuipackage";
import close from '../../../../../assets/images/Close_SuccessPopup.svg'

const Attachment = (props: any) => {
    return (<>
        <div className='itemDetails-attachment mt-3 mt-md-0'>
            <div className='attachementBlock mb-0'>
                <label>{props?.attachmentBtnText}</label>
                <div className='pull-right'>
                    <EventHandler onEvent={props?.handleAttachmentClick} data-attribute="Attachment_Default_EventHandler_4">
                        <span className='fa fa-paperclip me-2'></span>
                    </EventHandler>
                    <span className='fa fa-trash'></span>
                </div>
            </div>
            {
                props?.attachmentBtnClicked && <CustomTooltip header={<div>
                    <span className='head'> Attachments <Tooltip content='Allowed file formats are jpg, pdf, docx and xlsx. 
                    Upload files not more than 10MB. Only 5 files are allowed per Upload.'><span className='fa fa-info-circle attachment-info'> </span></Tooltip> </span>

                    <EventHandler onEvent={props.onCancelAttachment}>
                        <img src={close} alt='close' className='close-btn' />
                    </EventHandler>
                </div>} className='attachment-upload uploading' data-attribute="Attachment_Default_CustomTooltip">
                    <MultiFileUpload setAttachmentBtnClicked={props?.setAttachmentBtnClicked} attachmentBtnClicked={props?.attachmentBtnClicked} uploadErrMsg={props?.uploadErrMsg} setUploadErrMsg={props?.setUploadErrMsg} setIsLoading={props?.setIsLoading} id={0} noFiles={true} multiple={true} index={0}  data-attribute="Attachment_Default_MultiFileUpload" />
                </CustomTooltip>
            }
            {
                props?.isLoading ? <Spinner label="Uploading Attachments..." ariaLive="assertive" labelPosition="right"  data-attribute="Attachment_Default_Spinner" /> : null
            }
        </div>
    </>)
}

export default Attachment